import { getApiClient } from "../client";
import { CHARGE_POPULATE, REFUND_POPULATE } from "../populate";
import { ChargeSchema, RefundSchema, UpcomingChargesResponseSchema } from "../schemas";
import { validateResponse } from "../schemas/validation";
import { parseStrapiItemResponse, parseStrapiListResponse } from "../utils/parseStrapiResponse";
export const chargesEndpoints = {
    async getCharges(params) {
        const populate = params?.populate ?? CHARGE_POPULATE.FULL;
        const response = await getApiClient().get("/charges", {
            params: {
                populate,
                ...params,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: ChargeSchema,
            populate,
            context: "chargesEndpoints.getCharges",
        });
    },
    async getMyCharges(params) {
        const populate = params?.populate ?? CHARGE_POPULATE.FULL;
        const response = await getApiClient().get("/charges/me", {
            params: {
                populate,
                ...params,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: ChargeSchema,
            populate,
            context: "chargesEndpoints.getMyCharges",
        });
    },
    async setMyTrustpilotInvitationSent() {
        const response = await getApiClient().put("/charges/me/sent-trustpilot-invitation");
        return parseStrapiItemResponse(response.data);
    },
    async downloadInvoice(chargeId) {
        return getApiClient().getBlob(`/charges/${chargeId}/invoice`);
    },
    async downloadInvoices(chargeIds) {
        return getApiClient().postBlob("/charges/invoices", { ids: chargeIds });
    },
    async adminRefund(input) {
        const { chargeId, password, reason, amount } = input;
        const response = await getApiClient().post(`/charges/${chargeId}/refund`, { password, reason, amount });
        return parseStrapiItemResponse(response.data, {
            schema: RefundSchema,
            context: "chargesEndpoints.adminRefund",
        });
    },
};
export const refundsEndpoints = {
    async getRefunds(params) {
        const populate = params?.populate ?? REFUND_POPULATE.FULL;
        const response = await getApiClient().get("/refunds", {
            params: {
                populate,
                ...params,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: RefundSchema,
            populate,
            context: "refundsEndpoints.getRefunds",
        });
    },
    async getMyRefunds(params) {
        const populate = params?.populate ?? REFUND_POPULATE.FULL;
        const response = await getApiClient().get("/refunds/me", {
            params: {
                populate,
                ...params,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: RefundSchema,
            populate,
            context: "refundsEndpoints.getMyRefunds",
        });
    },
    async downloadInvoice(refundId) {
        return getApiClient().getBlob(`/refunds/${refundId}/invoice`);
    },
    async downloadInvoices(refundIds) {
        return getApiClient().postBlob("/refunds/invoices", { ids: refundIds });
    },
};
export const upcomingChargesEndpoints = {
    async getUpcomingCharges(params) {
        const response = await getApiClient().get("/subscriptions/upcoming-charges", { params });
        // Validate the custom response format directly (not Strapi list format)
        return validateResponse(UpcomingChargesResponseSchema, response.data, {
            context: "upcomingChargesEndpoints.getUpcomingCharges",
        });
    },
    async downloadPreviewInvoice(input) {
        return getApiClient().postBlob("/charges/preview-invoice", input);
    },
};
